import { lazy, type ComponentType } from 'react';

/**
 * A deploy renames every hashed chunk. A browser still running the previous
 * build then requests a route chunk that no longer exists; the static host
 * answers with index.html (text/html), the dynamic import throws, and the app
 * white-screens. Reload once to fetch the fresh index.html and its current
 * chunk names. The timestamp guard stops a genuine load failure from looping.
 */
// Mirrors React's own lazy() constraint. ComponentType<unknown> rejects every
// propless page component, because component props are contravariant.
export function lazyWithReload<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
) {
  return lazy(() =>
    factory().catch((error: unknown) => {
      const key = 'chunk-reload-at';
      const last = Number(sessionStorage.getItem(key) || 0);
      if (Date.now() - last > 10_000) {
        sessionStorage.setItem(key, String(Date.now()));
        window.location.reload();
        return new Promise<{ default: T }>(() => {});
      }
      throw error;
    }),
  );
}
